<div class="flex max-w-3xl flex-col gap-4">
  @for (entry of adminSections.entries(); track entry.id) {
    @if (entry.routerLink && entry.routerLink.length > 0) {
      <a
        class="block cursor-pointer rounded-xl no-underline text-inherit outline-none transition-shadow hover:shadow-md focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 dark:focus-visible:ring-offset-surface-900"
        [routerLink]="['/brightnav/admin', ...entry.routerLink]"
        [attr.aria-label]="'Open ' + entry.title"
      >
        <p-card>
          <div class="flex flex-col gap-2">
            <h2 class="text-lg font-semibold text-surface-900 dark:text-surface-0 m-0">{{ entry.title }}</h2>
            <p class="m-0 text-surface-700 dark:text-surface-200">{{ entry.description }}</p>
          </div>
        </p-card>
      </a>
    } @else {
      <p-card>
        <div class="flex flex-col gap-2">
          <h2 class="text-lg font-semibold text-surface-900 dark:text-surface-0 m-0">{{ entry.title }}</h2>
          <p class="m-0 text-surface-700 dark:text-surface-200">{{ entry.description }}</p>
        </div>
      </p-card>
    }
  } @empty {
    <p class="text-surface-600 dark:text-surface-400 m-0">
      No admin sections are registered yet. Feature libraries can call
      <code class="text-sm">provideAdminSectionEntry</code> from <code class="text-sm">@brighthub/admin-contract</code>.
    </p>
  }
</div>
